import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import _ from 'lodash'

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: ['Customer'],
  keepUnusedDataFor: 180,
  endpoints: (build) => ({
    getComplementaryType: build.query({
      query: () => {
        let user = localStorage.getItem('user')
        if (user) user = JSON.parse(user)
        return {
          url: '/customers/info',
          headers: {
            accessToken: user?.access_token,
            userId: user?.id,
          },
        }
      },
      transformResponse: (response) => [
        ..._.map(response.data.complementaryType, (n) => ({ label: n, value: n })),
      ],
    }),
    getCustomerInFo: build.query({
      query: () => {
        let user = localStorage.getItem('user')
        if (user) user = JSON.parse(user)
        return {
          url: '/customers/info',
          headers: {
            accessToken: user?.access_token,
            userId: user?.id,
          },
        }
      },
      transformResponse: (response) => {
        const { prefixTh, prefixEn, complementaryType } = response?.data || {}
        return {
          prefixTh: _.map(prefixTh, (n) => ({ label: n, value: n })),
          prefixEn: _.map(prefixEn, (n) => ({ label: n, value: n })),
          complementaryType: _.map(complementaryType, (n) => ({ label: n, value: n })),
        }
      },
    }),
  }),
})

export const {
  useGetComplementaryTypeQuery: useComplementaryType,
  useGetCustomerInFoQuery: useCustomerInfo,
} = customerApi
